<template>
  <div class="big">
    <div class="box" v-outSide>
      <el-input
        v-model="value1"
        placeholder="请选择"
        readonly="readonly"
        size="normal"
        suffix-icon="el-icon-date"
      ></el-input>

      <div class="picker" v-show="isShow">
        <div class="select">
          <span
            v-for="(item, index) in select"
            :key="index"
            @click="active(index)"
            :class="act == index ? 'active' : ''"
            >{{ item }}</span
          >
        </div>
        <day
          :key="`day${keys[0]}`"
          ref="day"
          @day="getDay"
          v-show="isShow && act == 0"
        />
        <week
          :key="`week${keys[1]}`"
          ref="week"
          v-show="isShow && act == 1"
          @week="getDay"
        />
        <month
          :key="`month${keys[2]}`"
          ref="month"
          v-show="isShow && act == 2"
          @month="getDay"
        />
        <year
          :key="`year${keys[3]}`"
          ref="year"
          v-show="isShow && act == 3"
          @year="getDay"
        />
      </div>
    </div>
    <div class="btn" v-if="isWeek">
      <el-button type="text" @click="up">上一周</el-button>
      <el-button type="text" @click="down">下一周</el-button>
    </div>
  </div>
</template>

<script>
import day from "./dateBasics/day";
import week from "./dateBasics/week";
import month from "./dateBasics/month.vue";
import year from "./dateBasics/year.vue";
import * as utils from "./utils";

export default {
  name: "DatePicker",
  props: {
    value: Object,
  },
  components: {
    day,
    week,
    month,
    year,
  },
  data() {
    return {
      value1: this.formteDate(new Date()),
      isShow: false,
      select: ["日", "周", "月", "学期"],
      act: 1,
      keys: [0, 1, 2, 3],
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    isWeek() {
      let arr = this.value1.split("至");
      let num = undefined;
      if (arr.length > 1) {
        num = this.$dayjs(arr[1]).diff(arr[0], "day");
        if (num > 1 && num < 7) {
          return true;
        }
        return false;
      }
    },
  },
  directives: {
    outSide: {
      bind(el, bindings, vnode) {
        el.hander = function (e) {
          if (el.contains(e.target)) {
            if (!vnode.context.isShow) {
              vnode.context.onFocus();
            }
          } else {
            if (vnode.context.isShow) {
              vnode.context.onblur();
            }
          }
        };
        document.addEventListener("click", el.hander);
      },
      unbind(el) {
        document.removeEventListener("click", el.hander);
      },
    },
  },
  watch: {
    value: {
      immediate: true, // 很重要！！！
      handler(val){
        this.$nextTick(()=>{
          this.init();
        })
      }
    },
  },

  methods: {
    init() {
      this.value1 = `${this.value.startDate} 至 ${this.value.endDate}`;
      let num = this.$dayjs(this.value.endDate).diff(
        this.value.startDate,
        "day"
      );
      this.$refs.day.$data.choiceDay = ''
      this.$refs.week.$data.choiceWeekAct=''
      this.$refs.month.$data.choiceM=''
      this.$refs.year.$data.actYear=''
      if (num == 0) {
        this.act = 0;
        this.$refs.day.$data.choiceDay = new Date(this.value.startDate);
        this.$refs.day.$data.month = new Date(this.value.startDate).getMonth()+1;
        this.$refs.day.$data.year = new Date(this.value.startDate).getFullYear();
        this.$refs.day.two();
      } else if (num == 6) {
        this.act = 1;
        // console.log(dayjs(this.value.startDate).get('year'),dayjs(this.value.startDate).get('month')+1);
        // this.$refs.week.getShowDays(dayjs(this.value.startDate).get('year'),dayjs(this.value.startDate).get('month'));
        this.$refs.week.$data.choiceWeekAct = new Date(this.value.startDate);
        this.$refs.week.$data.month = new Date(this.value.startDate).getMonth()+1;
        this.$refs.week.$data.year = new Date(this.value.startDate).getFullYear();
        this.$refs.week.two();
      } else if (num > 6 && num < 40) {
        this.act = 2;
        let { year, month } = utils.formatTime(new Date(this.value.startDate));
        this.$refs.month.$data.choiceM = `${year}-${month - 1}`;
        this.$refs.month.$data.year = year;
      } else {
        this.act = 3;
        this.$refs.year.$data.actYear = this.value.startDate.substr(0, 4)
        if (this.value.startDate.indexOf("15") != -1) {
          this.$refs.year.$data.act = 0;
          this.$refs.year.$data.actYear = Number(this.value.startDate.substr(0, 4))+1
        } else {
          this.$refs.year.$data.act = 1;
          this.$refs.year.$data.actYear = this.value.startDate.substr(0, 4)
        }
        this.$refs.year.$data.year = Number(this.$refs.year.$data.actYear);
      }
    },
    onFocus() {
      this.isShow = true;
    },
    onblur() {
      this.isShow = false;
    },
    active(i) {
      this.act = i;
    },
    formteDate(t) {
      let { year, month, day } = utils.formatTime(t);
      month = utils.padZero(month);
      day = utils.padZero(day);
      return `${year}-${month}-${day}`;
    },
    // 获取选中日
    getDay(v) {
      console.log(v);
      if (v.startDate == v.endDate) {
        this.value1 = `${this.formteDate(v.startDate)} 至 ${this.formteDate(
          v.startDate
        )}`;
      } else {
        this.value1 = `${this.formteDate(v.startDate)} 至 ${this.formteDate(
          v.endDate
        )}`;
      }
      let obj = {};
      obj.startDate = this.formteDate(v.startDate);
      obj.endDate = this.formteDate(v.endDate);
      this.$emit("dateValue", obj);
      let arr = JSON.parse(JSON.stringify(this.keys));
      arr.forEach((el, index) => {
        if (index != v.index) {
          arr[index] = el + 1;
        }
      });
      this.keys = arr;
      setTimeout(() => {
          this.onblur()
      }, 10);
    },
    // 上周
    up() {
      let arr = this.value1.split("至");
      let obj = {
        startDate: this.$dayjs(arr[0])
          .add(-1, "week")
          .startOf("week")
          .add(1, "day")
          .format("YYYY-MM-DD"),
        endDate: this.$dayjs(arr[0])
          .add(-1, "week")
          .endOf("week")
          .add(1, "day")
          .format("YYYY-MM-DD"),
      };
      //   this.$refs.week.$data.choiceWeekAct = new Date(this.value.startDate)
      this.$emit("dateValue", obj);
    },
    // 下周
    down() {
      let arr = this.value1.split("至");
      let obj = {
        startDate: this.$dayjs(arr[0])
          .add(+1, "week")
          .startOf("week")
          .add(1, "day")
          .format("YYYY-MM-DD"),
        endDate: this.$dayjs(arr[0])
          .add(+1, "week")
          .endOf("week")
          .add(1, "day")
          .format("YYYY-MM-DD"),
      };
      //   this.$refs.week.$data.choiceWeekAct = new Date(this.value.startDate)
      this.$emit("dateValue", obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.big {
  display: flex;
  align-items: center;
  .btn {
    margin-left: 2px;
  }
}
.box {
  font-size: 12px;
  width: fit-content;
}
.el-input {
  width: 217px;
}
.picker {
  width: 323px;
  height: auto;
  position: absolute;
  z-index: 3000;
  color: #606266;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e4e7ed;
  background-color: #fff;
  border-radius: 4px;
  line-height: 30px;
  margin: 5px 0;
  .select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e4e7ed;
    cursor: pointer;
    span {
      flex: 1;
      text-align: center;
      &:hover {
        background-color: #409eff;
        color: #fff;
      }
    }
    .active {
      background-color: #409eff;
      color: #fff;
    }
  }
}
</style>
